import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');

    // If a table uses our striped utility class, ensure striping continues from
    // the <thead> into the <tbody> (thead row count parity affects the offset).
    if (table.classList.contains('rte-table--striped')) {
      const theadRowCount = table.tHead?.rows?.length ?? 0;
      if (theadRowCount % 2 === 1) {
        table.classList.add('rte-table--striped--thead-odd');
      } else {
        table.classList.remove('rte-table--striped--thead-odd');
      }
    }

    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
